import React from 'react';

import Button from '../../Controls/Button';

import css from './style.module.scss';

interface Props {
  onButtonClick: () => void;
  isButtonVisible: boolean;
}

const ChatContainer = ({ onButtonClick, isButtonVisible }: Props) => {
  return (
    <div className={css.chatContainer}>
      <div className={css.chatContainer__wrap}>
        <div className={css.chatContainer__button}>
          {isButtonVisible && (
            <Button
              zIndex="1500"
              onClick={onButtonClick}
              icon="24--question-mark"
              iconSize="24"
              radius="circle"
              shape="square"
            />
          )}
        </div>
        <div id="chat-root"></div>
      </div>
    </div>
  );
};

export default ChatContainer;
